import { Error } from "@mui/icons-material";
import { Stack } from "@mui/material";

export type ErrorGuardProps = {
  error?: Error | string | null;
  children: React.ReactNode;
  iconSize?: number;
};

export function ErrorGuard({
  error: error,
  children,
  iconSize,
}: ErrorGuardProps) {
  if (error) {
    return (
      <Stack
        alignItems={"center"}
        justifyContent={"center"}
        flex={1}
        width={"100%"}
        height={"100%"}
      >
        <Error color="error" sx={{ fontSize: iconSize || 48, mb: 2 }} />
        <div>{typeof error === "string" ? error : error?.message}</div>
      </Stack>
    );
  }
  return <>{children}</>;
}
